import { Permission } from "./permissions.enum";

export class PermissionGroups {

  public static reportPermissions: Permission[] = [
    Permission.RapportBruttolöneavdrag,
    Permission.RapportKostnadsöversiktFörare,
    Permission.RapportKostnadsöversiktFöretag,
    Permission.RapportVagnsparksöversikt,
    Permission.RapportTotalaKostnader,
    Permission.RapportMiljörapport,
    Permission.RapportRapporteradKörsträcka,
    Permission.RapportTransaktionslista,
    Permission.RapportFörmånsvärdesammanställning,
    Permission.RapportLöneunderlag,
    Permission.RapportSplittberäkningFörare
  ];

  public static all: Permission[] = Object.values(Permission);

  public static internalUserPermissions: Permission[] = [
    Permission.AdministreraSamarbetspartners,
    Permission.AdministreraAssistansbolag,
    Permission.AdministreraVanligaFrågor,
    Permission.AdministreraInformationOchBlanketter,
    Permission.AdministreraNyheter,
    Permission.AdministreraStatusExternKörjournalsrapportering,
    Permission.AdministreraExternaKörjournalsrapporter,
    Permission.KörSomAnnan,
    Permission.AdministreraAllaAnvändare,
    Permission.AdministreraAvropsinställningar
  ];

  public static get externalUserPermissions(): Permission[] {
    return this.all.filter((item) => {
      return this.internalUserPermissions.findIndex(internal => internal.toString() === item.toString()) === -1;
    });
  }

  public static get administrationPermissions(): Permission[] {
    return this.internalUserPermissions.filter((item) => {
      return  item != Permission.KörSomAnnan;
    }); 
  }

  public static supportCasePermissions: Permission[] = [
    Permission.LäsaÄndraFörareÄrende,
    Permission.LäsaÄndraKostnadsställeÄrende,
    Permission.LäsaÄndraBilkategoriÄrende,
    Permission.LäsaBeställDrivmedelskortÄrende,
    Permission.LäsaÄndraFöraruppgifterÄrenden,
    Permission.SkapaÄndraFörareÄrende,
    Permission.SkapaÄndraKostnadsställeÄrende,
    Permission.SkapaÄndraBilkategoriÄrende,
    Permission.SkapaBeställDrivmedelskortÄrende,
    Permission.SkapaÄndraFöraruppgifterÄrendeAllaUppgifter,
    Permission.SkapaÄndraFöraruppgifterÄrendeEndastAnställningsnummer
  ];

  public static readSupportCasePermissions: Permission[] = [
    Permission.LäsaÄndraFörareÄrende,
    Permission.LäsaÄndraKostnadsställeÄrende,
    Permission.LäsaÄndraBilkategoriÄrende,
    Permission.LäsaBeställDrivmedelskortÄrende,
    Permission.LäsaÄndraFöraruppgifterÄrenden
  ];

  public static createSupportCasePermissions: Permission[] = [
    Permission.SkapaÄndraFörareÄrende,
    Permission.SkapaÄndraKostnadsställeÄrende,
    Permission.SkapaÄndraBilkategoriÄrende,
    Permission.SkapaBeställDrivmedelskortÄrende,
    Permission.SkapaÄndraFöraruppgifterÄrendeAllaUppgifter,
    Permission.SkapaÄndraFöraruppgifterÄrendeEndastAnställningsnummer
  ];

  public static companyPermissions: Permission[] = [
    Permission.Vagnparksöversikt,
    Permission.LäsaFöretagsbilarSomLöperUt,
    Permission.AdministreraAvrop,
    Permission.AdministreraFleetCCAvrop,
    Permission.LäsaFakturor,
    Permission.AdministreraFöretagsanvändare,
    Permission.LäsaFöretagsanvändare
  ]
}
